// Modal thêm người ký giữa quy trình — markup như V1.
import React from "react";
import { Modal } from "react-bootstrap";
import SearchBoxModal from "../../component/SearchBoxModal";

export default function AddMemberModal({ show, onHide, dataNewMember, setDataNewMember, actionAddMember }) {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="w-100 d-flex justify-content-between align-items-center">
            <h5 className="modal-title">Thêm người ký</h5>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12 form-group">
            <label>Chọn nhân sự</label>
            <SearchBoxModal
              apiname={"users"}
              placeholder="Chọn nhân sự"
              colvalue={"id"}
              colname={"fullname"}
              defaultValue={dataNewMember && dataNewMember.user_id}
              name="new_member"
              onChange={async (e) => setDataNewMember({ ...dataNewMember, user_id: e })}
            ></SearchBoxModal>
          </div>
          <div className="col-12 form-group text-center">
            <button type="button" className="btn btn-sm btn-success" onClick={() => actionAddMember()}>
              Thêm vào quy trình
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
